import { useCallback, useEffect, useRef } from 'react';

interface Props {
  intervalCallbackAction: () => void;
  time?: number;
}

const useIntervalAction = ({ intervalCallbackAction, time = 3000 }: Props) => {
  const intervalId = useRef<number | null>(null);
  const callbackRef = useRef<() => void>(() => {});

  useEffect(() => {
    callbackRef.current = intervalCallbackAction;
  }, [intervalCallbackAction]);

  const startInterval = useCallback(() => {
    if (intervalId.current) {
      clearInterval(intervalId.current);
    }

    if (callbackRef.current) {
      intervalId.current = setInterval(
        () => callbackRef.current(),
        time,
      ) as unknown as number;
    }
  }, [intervalCallbackAction]);

  const clearIntervalAction = useCallback(() => {
    if (intervalId.current) {
      clearInterval(intervalId.current);
      intervalId.current = null;
    }
  }, [intervalId]);

  return {
    startInterval,
    clearIntervalAction,
  };
};

export default useIntervalAction;
